// @TODO: higher order component to handle displaying

import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { HtmlContent } from "../HtmlContent";
import {
    CloseIcon,
    Icon,
    NoticeErrorIcon,
    NoticeInfoIcon,
    NoticeSuccessIcon,
    NoticeWarningIcon,
} from "../Icon";
import styles from "./Notice.style";

const NoticeStyled = styled.div((props) => ({ ...styles(props) }));

const Notice = ({
    title,
    message,
    children,
    severity,
    onClose,
    actionComponent: Action,
    disableIcon,
    className,
    ...rest
}) => (
    <NoticeStyled className={className} severity={severity} {...rest}>
        {severity && !disableIcon && (
            <div className="noticeIcon">
                {
                    {
                        success: <Icon icon={NoticeSuccessIcon} viewBox="0 0 40 40" />,
                        info: <Icon icon={NoticeInfoIcon} viewBox="0 0 40 40" />,
                        warning: <Icon icon={NoticeWarningIcon} viewBox="0 0 40 40" />,
                        error: <Icon icon={NoticeErrorIcon} viewBox="0 0 40 40" />,
                    }[severity]
                }
            </div>
        )}
        <div className="noticeContent">
            {(title || message) && (
                <div className="noticeContent_default">
                    {title && (
                        <HtmlContent
                            content={title}
                            className="noticeTitle"
                            wrapperComponent="div"
                        />
                    )}
                    {message && (
                        <HtmlContent
                            content={message}
                            className="noticeMessage"
                            wrapperComponent="div"
                        />
                    )}
                </div>
            )}
            {children}
        </div>
        {(onClose || Action) && (
            <div className="noticeAction">
                {Action && <Action />}
                {!Action && onClose && (
                    <button
                        type="button"
                        aria-label="Zatvori"
                        title="Zatvori"
                        className="noticeAction_btn"
                        onClick={onClose}
                    >
                        <Icon icon={CloseIcon} size={32} />
                    </button>
                )}
            </div>
        )}
    </NoticeStyled>
);

const noticeSeverity = Object.freeze({
    SUCCESS: "success",
    INFO: "info",
    WARNING: "warning",
    ERROR: "error",
});

Notice.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    className: PropTypes.string,
    severity: PropTypes.oneOf([...Object.values(noticeSeverity)]),
    onClose: PropTypes.func,
    actionComponent: PropTypes.elementType,
    disableIcon: PropTypes.bool,
};

Notice.defaultProps = {
    title: undefined,
    message: undefined,
    className: undefined,
    severity: undefined,
    onClose: undefined,
    actionComponent: undefined,
    disableIcon: false,
};

export { noticeSeverity };

export default Notice;
